<style lang="scss" scoped>
	.appoint-home-g {
		position: relative;
		width: 380px;
		height: 100%;
		margin: 0 auto;
		overflow: auto;
		background: url('../../assets/appointment/home-bg.png') center;
	}
	.appoint-info {
		position: fixed;
		z-index: 99;
		left: 0;
		right: 0;
		margin: 0 auto;
		bottom: 20px;
		width: 330px;
		height: 88px;
		background: url('../../assets/appointment/mobile/appoint-number-bg.png') no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-size: 14px;
		color: #f4ebe5;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 2%;
		padding-left: 6%;
		.new-appoint-btn {
			width: 30%;
		}
		.go-past {
			width: 28%;
			img {
				width: 100%;
				margin-top: 4px;
			}
		}
	}
	.game-frame {
		position: absolute;
		z-index: 99;
		top: 40px;
		right: 20px;
		width: 70px;
		height: 80px;
		background: url("../../assets/appointment/suspended-frame1.png");
		background-size: 100% 100%;
		text-align: center;
		.item {
			line-height: 40px;
			font-size: 14px;
		}
	}
	.top {
		position: relative;
		width: 100%;
		height: auto;
		overflow: auto;
		.home-top-bg {
			width: 100%;
			height: auto;
		}
		.logo {
			position: absolute;
			bottom: 100px;
			left: 0;
			right: 0;
			margin: 0 auto;
			height: 200px;
		}
		.video-btn {
			position: absolute;
			height: 85px;
			padding-left: 55%;
			bottom: 95px;
			left: 0;
			right: 0;
			margin: 0 auto;
		}
		.pumping-activities-title {
			position: absolute;
			bottom: 15px;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 73%;
		}
	}
	.pumping-activities {
		position: relative;
		z-index: 0;
		width: 100%;
		overflow: hidden;
		text-align: center;
		.circle {
			position: relative;
			width: 100%;
			animation:animation1 40s linear infinite;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.icon1 {
			width: 60%;
			margin-top: 20px;
		}
		.icon2 {
			width: 100%;
			margin-top: 10px;
			margin-bottom: 5px;
		}
		.btn {
			width: 34%;
		}
		.grade {
			position: absolute;
			width: 100%;
			text-align: center;
			.card {
				width: 30%;
				margin-left: 1.5%;
    			margin-right: 1.5%;
			}
		}
	}
	.role-card {
		position: relative;
		width: 100%;
		height: auto;
		overflow: auto;
		text-align: center;
		.background {
			width: 100%;
		}
		.title {
			position: absolute;
			top: 70px;
			left: 0;
			right: 0;
			width: 80%;
			margin: 0 auto;
		}
		.role {
			position: absolute;
			left: 0;
			top: 100px;
			width: 100%;
		}
		.voice-block {
			position: absolute;
			bottom: 125px;
			left: 3%;
			width: 94%;
			height: 80px;
			background: url('../../assets/mobile/role-voice-bg.png');
			background-size: 100% 100%;
			.china-voice,
			.japan-voice {
				width: 85%;
				height: 39px;
				margin-left: 12%;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				font-size: 12px;
				letter-spacing: 1px;
				.voicer {
					width: 22%;
					color: #5c4320;
				}
				.voice-btn {
					width: 8%;
				}
				.voice-word {
					color: #6a5521;
					transform: scale(0.9);
					width: 80%;
					height: 40px;
					overflow: hidden;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
				}
			}
		}
		.role-head-list {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 50px;
			width: 100%;
			height: 65px;
			text-align: left;
			background: url("../../assets/appointment/mobile/character-head-bg.png") center no-repeat;
			overflow-x: auto;
			display: flex;
			justify-content: flex-start;
			.role-head {
				height: 100%;
				width: auto;
				cursor: pointer;
				margin-left: 6px;
				margin-right: 5px;
			}
		}
	}
	.more-activity {
		width: 100%;
		overflow: auto;
		text-align: center;
		.title {
			width: 80%;
			margin-top: 10px;
			margin-bottom: 5px;
		}
		.card {
			width: 30%;
			height: auto;
			margin-left: 1.5%;
			margin-right: 1.5%;
		}
	}
	.game-feature {
		width: 100%;
		overflow: auto;
		text-align: center;
		.title {
			width: 80%;
			margin-top: 20px;
			margin-bottom: 5px;
		}
		.card-list {
			width: 86%;
			margin-left: 7%;
			display: flex;
			justify-content: space-around;
		}
		.card {
			position: relative;
			width: 33%;
			background-size: 100% 100%;
			overflow: hidden;
			.role {
				width: 100%;
			}
			.voice-btn {
				width: 15%;
				position: absolute;
				bottom: 18px;
			}
		}
	}
	.show-content {
		width: 100%;
		text-align: center;
		overflow: auto;
		.title {
			width: 80%;
			margin-top: 20px;
			margin-bottom: 20px;
		}
		.content {
			width: 100%;
			display: flex;
			justify-content: space-around;
		}
		.type,
		.image {
			height: 260px;
		}
	}
	.contact-type {
		width: 80%;
		margin-left: 10%;
		overflow: auto;
		background: url('../../assets/appointment/mobile/contact-type-bg.png');
		background-size: 100% 100%;
		padding-left: 5px;
    	padding-right: 5px;
    	margin-top: 30px;
		.content {
			width: 100%;
		}
	}
	.footer {
		position: relative;
		width: 100%;
		height: 150px;
		background: url('../../assets/appointment/mobile/footer-bg.png');
		background-size: 100% 100%;
		text-align: center;
		color: #f4ebe5;
		font-size: 12px;
		line-height: 18px;
		.footer-logo {
			position: absolute;
			top: 23px;
			left: 15%;
			width: 50px;
		}
		.footer-icon {
			margin-top: 45px;
			margin-bottom: 5px;
			width: 30%;
		}
		.word {
			transform: scale(0.9);
		}
	}
	.phone-block {
		position: relative;
		background: url('../../assets/appointment/login-ct-bg.png');
		background-size: 100% 100%;
		text-align: center;
		width: 94%;
		max-width: 414px;
		height: 32vh;
		min-height: 220px;
		padding-top: 10vh;
		.go-back {
			position: absolute;
			top: 3px;
			right: 0;
			width: 25px;
		}
		.name {
			font-size: 14px;
			margin-bottom: 20px;
			text-align: right;
			color: #78567d;
		}
		.input {
			text-align: left;
			input {
				width: 80%;
				height: 24px;
				border: none;
				outline: none;
				background: #d3b8c8;
				margin-left: 5px;
				padding-left: 5px;
			}
		}
		.login-btn {
			height: 4vh;
			cursor: pointer;
			margin-bottom: 10px;
			margin-top: 5px;
		}
		.tip {
			padding-left: 10%;
			padding-right: 10%;
			font-size: 12px;
			color: #78567d;
			transform: scale(0.9);
		}
	}
	.slide-fade-enter-active {
		transition: all 2s ease;
	}
	.slide-fade-enter {
		opacity: 0;
	}
	.activity-modal-content {
		position: relative;
		width: 350px;
		height: 600px;
		.hide-btn {
			position: absolute;
			top: 35px;
			right: 10px;
		}
		.content3 {
			position: absolute;
			bottom: 38px;
			padding-left: 10%;
			.friend-invitation-btn {
				width: 31%;
				margin-left: 15px;
			}
			.number {
				float: left;
				font-size: 12px;
				line-height: 4vh;
				color: #786b8d;
			}
			.tip {
				float: left;
				color: #ee9389;
				font-size: 12px;
				line-height: 4vh;
				transform: scale(0.9);
			}
			.input {
				height: 26px;
				border: none;
				outline: none;
				background: #d3b8c8;
				padding-left: 5px;
				float: left;
			}
		}
	}
</style>

<template>
	<div class="appoint-home-g">
		<!-- 预约悬浮框 -->
		<div v-show="appointInfoState=='1'" class="appoint-info">
			<div class="number">
				<span>当前预约人数</span><br>
				<span style="font-size: 18px;">{{appointNumber}}</span>
			</div>
			<img @click="getAppoint" class="new-appoint-btn" src="../../assets/appointment/new-appoint-btn.png" alt="">
			<div class="go-past">
				<!-- <img src="../../assets/appointment/not-go-past-btn.png" alt=""> -->
			</div>
		</div>
		<!-- 返回悬浮框 -->
		<div class="game-frame">
			<div style="color: #e1e1e1;" class="item">返回官网</div>
			<div class="item">
				<a style="color: #515a6e;" href="http://uri6.com/tkio/FNJNrea">立即下载</a>
			</div>
		</div>
		<!-- 顶部 -->
		<div class="top">
			<img class="home-top-bg" src="../../assets/appointment/mobile/home-top-bg.jpg" alt="">
			<img class="logo" src="../../assets/appointment/home-logo.png" alt="logo">
			<img @click="playVideo" class="video-btn" src="../../assets/appointment/video-btn.png" alt="">
			<img class="pumping-activities-title" src="../../assets/appointment/mobile/pumping-activities-title.png" alt="">
		</div>
		<!-- 预抽卡活动 -->
		<div class="pumping-activities">
			<img class="circle" src="../../assets/appointment/mobile/pumping-activities-circle.png" alt="">
			<div style="top: 10px;" class="grade grade1">
				<img class="card" src="../../assets/appointment/mobile/pumping-card1.png" alt="">
				<img class="card" src="../../assets/appointment/mobile/pumping-card2.png" alt="">
			</div>
			<div style="top: 70px;" class="grade grade2">
				<img class="card" src="../../assets/appointment/mobile/pumping-card3.png" alt="">
				<img style="position: relative; top: 30px;" class="card" src="../../assets/appointment/mobile/pumping-card4.png" alt="">
				<img class="card" src="../../assets/appointment/mobile/pumping-card5.png" alt="">
			</div>
			<div style="top: 160px;" class="grade grade3">
				<img class="card" src="../../assets/appointment/mobile/pumping-card6.png" alt="">
				<img class="card" src="../../assets/appointment/mobile/pumping-card7.png" alt="">
			</div>
			<div style="top: 230px;" class="grade grade4">
				<img class="card" src="../../assets/appointment/mobile/pumping-card8.png" alt="">
			</div>
			<img class="icon1" src="../../assets/appointment/mobile/pumping-activities-icon1.png" alt="">
			<img class="icon2" src="../../assets/appointment/mobile/pumping-activities-icon2.png" alt="">
			<img @click="clickPumpCard" class="btn" src="../../assets/appointment/mobile/pumping-activities-btn.png" alt="">
		</div>
		<!-- 卡牌人物 -->
		<div class="role-card">
			<img class="background" src="../../assets/appointment/mobile/role-card-bg.jpg" alt="">
			<img class="title" src="../../assets/appointment/mobile/role-card-title.png" alt="title">
			<template v-for="(item, index) in roleList" >
				<transition name="slide-fade" :key="item.figureId">
					<img
						v-show="roleChooseIndex == index"
						:src="item.figureImagePath"
						:alt="item.figureImageName"
						class="role"
					>
				</transition>
			</template>
			<div class="voice-block">
				<div class="china-voice">
					<div class="voicer">{{roleChoose.figureVoiceNameZhong}}</div>
					<img @click="playChinaVoice" class="voice-btn" src="../../assets/pc/voice-btn.png" alt="">
					<div class="voice-word">{{roleChoose.figureVoiceTextZhong}}</div>
				</div>
				<audio :src="roleChoose.figureVoiceFilePathZhong" id="china_audio"></audio>
				<div class="japan-voice">
					<div class="voicer">{{roleChoose.figureVoiceNameRi}}</div>
					<img @click="playJapanVoice" class="voice-btn" src="../../assets/pc/voice-btn.png" alt="">
					<div class="voice-word">{{roleChoose.figureVoiceTextRi}}</div>
				</div>
				<audio :src="roleChoose.figureVoiceFilePathRi" id="japan_audio"></audio>
			</div>
			<div class="role-head-list">
				<img v-for="(item, index) in roleHeadList" :key="item.id" @click="chooseRole(index)" class="role-head" :src="item.path" alt="">
			</div>
		</div>
		<!-- 更多活动 -->
		<div class="more-activity">
			<img class="title" src="../../assets/appointment/mobile/more-activity-title.png" alt=""><br>
			<img @click="showActivity('1')" class="card" src="../../assets/appointment/more-activity-card1.png" alt="">
			<img @click="showActivity('2')" class="card" src="../../assets/appointment/more-activity-card2.png" alt="">
			<img @click="showActivity('3')" class="card" src="../../assets/appointment/more-activity-card3.png" alt="">
		</div>
		<!-- 游戏特色 -->
		<div class="game-feature">
			<img class="title" src="../../assets/appointment/mobile/game-feature-title.png" alt="">
			<div class="card-list">
				<div
					v-for="item in gameFeature1"
					:key="item.id"
					class="card"
				>
					<img class="role" :src="item.bgPath" alt="">
					<img @click="playJapanVoice1(item.index)" style="left: 29px;" class="voice-btn" src="../../assets/appointment/voice-btn2.png" alt="">
					<img @click="playChinaVoice1(item.index)" style="right: 36px;" class="voice-btn" src="../../assets/appointment/voice-btn2.png" alt="">
				</div>
			</div>
			<div class="card-list">
				<div
					v-for="item in gameFeature2"
					:key="item.id"
					class="card"
				>
					<img class="role" :src="item.bgPath" alt="">
					<img @click="playJapanVoice1(item.index)" style="left: 29px;" class="voice-btn" src="../../assets/appointment/voice-btn2.png" alt="">
					<img @click="playChinaVoice1(item.index)" style="right: 36px;" class="voice-btn" src="../../assets/appointment/voice-btn2.png" alt="">
				</div>
			</div>
		</div>
		<!-- 内容展示 -->
		<div class="show-content">
			<img class="title" src="../../assets/appointment/mobile/show-content-title.png" alt="">
			<div class="content">
				<img v-show="showContentNumber == '1'" class="image" src="../../assets/appointment/mobile/show-content-image1.png" alt="">
				<img @click="showContentNumber = '1'" class="type" src="../../assets/appointment/mobile/show-content1.png" alt="">
				<img v-show="showContentNumber == '2'" class="image" src="../../assets/appointment/mobile/show-content-image2.png" alt="">
				<img @click="showContentNumber = '2'" class="type" src="../../assets/appointment/mobile/show-content2.png" alt="">
				<img v-show="showContentNumber == '3'" class="image" src="../../assets/appointment/mobile/show-content-image3.png" alt="">
				<img @click="showContentNumber = '3'" class="type" src="../../assets/appointment/mobile/show-content3.png" alt="">
				<img v-show="showContentNumber == '4'" class="image" src="../../assets/appointment/mobile/show-content-image4.png" alt="">
				<img @click="showContentNumber = '4'" class="type" src="../../assets/appointment/mobile/show-content4.png" alt="">
			</div>
		</div>
		<!-- 联系途径 -->
		<div class="contact-type">
			<img class="content" src="../../assets/appointment/mobile/contact-type-ct.png" alt="">
		</div>
		<!-- footer -->
		<div class="footer">
			<img class="footer-logo" src="../../assets/appointment/mobile/footer-logo.png" alt="">
			<img class="footer-icon" src="../../assets/appointment/mobile/footer-icon.png" alt="">
			<div class="word">
				<span style="margin-right: 10px;">家长监护</span>
				<span>适龄提示：本游戏适合18岁（含）以上玩家娱乐</span>
			</div>
			<div class="word">
				<span>互联网ICP备案：<a @click="goPage">沪ICP备13003575-1号</a> | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span>沪公网安备 31011502017186号 | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span style="margin-right: 10px;">地址：上海市浦东新区乳山路233号德必WE402</span>
				<span>客服电话：021-58385528</span>
			</div>
		</div>
		<!-- 视频播放 -->
		<div @click="hideVideo" v-show="videoShow" class="modal-block">
			<video
				id="video"
				src="http://fbbsoc-download.joymore.cn/brotherland/website/video-all.mp4"
				x5-video-player-type='h5'
				x5-video-player-fullscreen='true'
				playsinline
				webkit-playsinline
			></video>
		</div>
		<!-- 活动列表 -->
		<div v-show="activityShow" class="modal-block" style="overflow: auto; align-items: flex-start">
			<div class="activity-modal-content">
				<img @click="activityShow=false" class="hide-btn" src="../../assets/pc/hide-btn.png" alt="">
				<img v-show="activityNumber == '1'" style="width: 100%;" src="../../assets/appointment/mobile/more-activity1.png" alt="">
				<img v-show="activityNumber == '2'" style="width: 100%;" src="../../assets/appointment/mobile/more-activity2.png" alt="">
				<img v-show="activityNumber == '3'" style="width: 100%;" src="../../assets/appointment/mobile/more-activity3.png" alt="">
				<!-- 活动三内容 -->
				<div v-show="activityNumber == '3'" class="content3">
					<input class="input" id="copyword" v-model="friendInvitationLink" type="text">
					<img @click="friendInvitation" class="friend-invitation-btn" src="../../assets/appointment/friend-invitation-btn.png" alt=""><br>
					<div class="number">已成功邀请{{friendInvitationNumber}}好友</div>
					<div v-show="gamePhoneNumber" class="tip">PS:点击邀请按钮，即可复制分享链接</div>
					<div v-show="!gamePhoneNumber" class="tip">PS:成功预约后可复制邀请链接</div>
				</div>
			</div>
		</div>
		<!-- 背景音乐 -->
		<!-- <audio
			autoplay
			loop="loop"
			:src="voicePath"
			id="bg_voice"
		>您的浏览器不支持 audio 标签。</audio> -->
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			voicePath: require('../../assets/background-voice.mp3'),
			appointNumber: 0,
			videoShow: false,
			roleList: [
				{
					figureId: 1,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role1.png',
					figureImageName: '房芝',
					figureVoiceNameZhong: '马洋',
					figureVoiceTextZhong: '今夜的星月真美啊……小、小生想邀公子一同去赏月，可、可以么？',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-房芝.wav',
					figureVoiceNameRi: '小野贤章',
					figureVoiceTextRi: '从小生不再害怕坠落的那一刻起，才发现天空如此广阔。',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-房芝+125.wav',
					figureCharacter: '他腼腆内敛,以一双巧手编织精致的锦衣华服。虽然与人交流会害羞,却心细如丝,纵然是一瞬而过的失落也会被他轻易捕捉。在他小心翼翼地将真实层层包裹后,会是谁让他敞开心扉呢？'
				},
				{
					figureId: 2,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role2.png',
					figureImageName: '花想容',
					figureVoiceNameZhong: '谢添天',
					figureVoiceTextZhong: '别眨眼啊，这样的景色哪怕错过一秒，也是你的损失。',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-花想容.wav',
					figureVoiceNameRi: '森久保祥太郎',
					figureVoiceTextRi: '蝴蝶恋花，到底是钦慕它的美，还是别有目的呢？',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-花想容+052.wav',
					figureCharacter: '金池国的大臣,喜欢搜集一切与美相关的事物。他挑剔却也精致,就这样一个绝对自信之人，却每每在月圆之夜隐去行踪躲了起来,因为他有一个不能说的秘密。'
				},
				{
					figureId: 3,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role3.png',
					figureImageName: '储阳',
					figureVoiceNameZhong: '冯骏骅',
					figureVoiceTextZhong: '小阳祈愿，福运会一直降临在姐姐身上。',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-储阳.wav',
					figureVoiceNameRi: '神前有纪',
					figureVoiceTextRi: '如果许下的愿望都能实现，那该有多好啊……',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-储阳+071.wav',
					figureCharacter: '腼腆的小亲王,即使儿时记忆片空白,他也依旧开朗懂事。他的世界很单纯不带丝阴霾 ,可就是这样天真无害的他,却被王宫中人深深忌惮着。因为有时候,他不再是“他”。'
				},
				{
					figureId: 4,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role4.png',
					figureImageName: '景逸',
					figureVoiceNameZhong: '沈达威',
					figureVoiceTextZhong: '不再翱翔于天际的鸟，只是因为找到了新的信仰。',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-景逸.wav',
					figureVoiceNameRi: '小野友树',
					figureVoiceTextRi: '清醒的人，反倒会很无趣啊。',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-景逸+045.wav',
					figureCharacter: '临宸国身世成谜的小王子、志在山野、远离权势，却又在一夜间登上王位。玩世不恭是所有人对他的第一印象、无人知在放荡不羁的神情下、他究竟藏着怎样的心思。'
				},
				{
					figureId: 5,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role5.png',
					figureImageName: '宁佑',
					figureVoiceNameZhong: '孙晔',
					figureVoiceTextZhong: '最好的武器是内心的意志。',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-宁佑.wav',
					figureVoiceNameRi: '柿原彻也',
					figureVoiceTextRi: '无畏无惧，什么地方都敢闯，我就是草原第一勇者！',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-宁佑+221.wav',
					figureCharacter: '曾是一个与狼为伍的狼孩,被罕牛部落的荣必图收养为弟弟残酷的战争夺去部落无数生命,他尝到失去的滋味,却没有磨灭勇士精神。当此生最重要的人出现时,他的勇气又将带给他怎样的未来?'
				},
				{
					figureId: 6,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role6.png',
					figureImageName: '神秘男子',
					figureVoiceNameZhong: '夏磊',
					figureVoiceTextZhong: '春雷已响，锐不可当。',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-景鸿.wav',
					figureVoiceNameRi: '新垣樽助',
					figureVoiceTextRi: '命运终将被我主宰，你也一样。',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-景鸿+099.wav',
					figureCharacter: '曾经的他即将站到权力之巅、却又在一夕之间失去了所有。从牢狱逃离后踏上复仇之路,他不惜唤醒沉睡千年的魔并与之缔结契约。我行我素、霸道自我是他的行为准则,他想得到的事物便定能得到,从无例外。'
				},
				{
					figureId: 7,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role7.png',
					figureImageName: '无赦',
					figureVoiceNameZhong: '赵路',
					figureVoiceTextZhong: '一副没精打采的样子呢……来点痛苦提提神吧？',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-无赦.wav',
					figureVoiceNameRi: '小西克幸',
					figureVoiceTextRi: '死亡的生命已经腐朽，而吾却得到了永恒。',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-无赦+012.wav',
					figureCharacter: '冥离山之主,魔族的魁首。拥有一眼窥破他人心魔的能力传闻有能入他人梦境,诱人堕落的异瞳妖魔,似乎就与他有关。千年前因故被封印,如今重新现世。意图毁灭一切,让这世间沦为弱肉强食,纵容一切欲望的恶土。'
				},
				{
					figureId: 8,
					figureImagePath: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-mobile-role8.png',
					figureImageName: '云尘',
					figureVoiceNameZhong: '王梓',
					figureVoiceTextZhong: '若能将此举奏与你听，此生也不算遗憾',
					figureVoiceFilePathZhong: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-云尘.wav',
					figureVoiceNameRi: '森川智之',
					figureVoiceTextRi: '渺渺烟云，微如尘埃。天下万灵，何有不同？',
					figureVoiceFilePathRi: 'http://fbbsoc-download.joymore.cn/brotherland/website/a-云尘+106.wav',
					figureCharacter: '他从千年的沉睡中醒来,为的,是让整个大陆繁衍重新踏上正轨。他用最大的善意对待世间所有生灵,却无法伸手触碰他们。因为他体温极低,触碰之处皆会覆上一层寒霜。'
				}
			],
			roleHeadList: [
				{path: require('../../assets/appointment/role-head1.png'), id: '1'},
				{path: require('../../assets/appointment/role-head2.png'), id: '2'},
				{path: require('../../assets/appointment/role-head3.png'), id: '3'},
				{path: require('../../assets/appointment/role-head6.png'), id: '4'},
				{path: require('../../assets/appointment/role-head5.png'), id: '5'},
				{path: require('../../assets/appointment/role-head4.png'), id: '6'},
				{path: require('../../assets/appointment/role-head7.png'), id: '7'},
				{path: require('../../assets/appointment/role-head8.png'), id: '8'}
			],
			roleChooseIndex: 0,
			chinaVoiceRoot: null,
			japanVoiceRoot: null,
			activityShow: false,
			activityNumber: 1,
			gameFeature1: [
				{
					id: '1',
					bgPath: require('../../assets/appointment/mobile/game-feature1.png'),
					index: 3
				},
				{
					id: '2',
					bgPath: require('../../assets/appointment/mobile/game-feature2.png'),
					index: 7
				},
				{
					id: '3',
					bgPath: require('../../assets/appointment/mobile/game-feature3.png'),
					index: 1
				}
			],
			gameFeature2: [
				{
					id: '4',
					bgPath: require('../../assets/appointment/mobile/game-feature4.png'),
					index: 5
				},
				{
					id: '5',
					bgPath: require('../../assets/appointment/mobile/game-feature5.png'),
					index: 6
				},
				{
					id: '6',
					bgPath: require('../../assets/appointment/mobile/game-feature6.png'),
					index: 0
				}
			],
			showContentNumber: '3',
			gamePhoneNumber: '', // 手机号
			phoneBlockShow: false, // 手机号输入弹窗
			typeClick: '1', // 1预约，2记忆通道， 3抽卡
			friendInvitationNumber: 0,
			friendInvitationLink: '',
			invitePhone: '', // 邀请手机号
			appointInfoState: '1', //'1'：显示，'0'：不显示
		}
	},
	computed: {
		roleChoose() {
			return this.roleList[this.roleChooseIndex];
		}
	},
	watch: {
		roleChooseIndex() {
			this.chinaVoiceRoot.load();
			this.japanVoiceRoot.load();
		}
	},
	mounted() {
		this.chinaVoiceRoot = document.getElementById('china_audio');
		this.japanVoiceRoot = document.getElementById('japan_audio');

		this.gamePhoneNumber = this.$route.query.phone;
		let host = window.location.host;
		this.friendInvitationLink = host + '/appoint-home-m?invitePhone=' + this.gamePhoneNumber;


		let invitePhone = this.$route.query.invitePhone;
		if(invitePhone) {
			this.invitePhone = invitePhone;
		}

		this.getAppoint();


		// document.addEventListener('visibilitychange', function () {
		// 	// 用户离开了当前页面
		// 	if (document.visibilityState === 'hidden') {
		// 		document.getElementById("bg_voice").pause();
		// 	}
		// 	// 用户打开或回到页面
		// 	if (document.visibilityState === 'visible') {
		// 		document.getElementById("bg_voice").play();
		// 	}
		// });
	},
	methods: {
		getAppoint() {
			this.$http.get("/api/subscribe/saveAccountInfo?invitePhone=&phone=" + this.gamePhoneNumber).then((res) => {
				this.appointInfoState = res.result.status;
				this.getAppointNumber();
				// if(this.appointInfoState == '0') {
				// 	this.$Message.success("您已预约成功");
				// }
			});
		},
		// 获取预约人数
		getAppointNumber() {
			this.$http.get('/api/subscribe/getSubscribeCount?phone=' + this.gamePhoneNumber).then(res => {
				this.appointNumber = res.result.subscribeCount;
				this.friendInvitationNumber = res.result.inviteNum;
			});
		},
		// 点击抽卡
		clickPumpCard() {
			this.$router.push({name: 'pumping-card-g', query: {phone: this.gamePhoneNumber}});
		},
		// 点击分享按钮
		friendInvitation() {
			this.copy();
		},
		// 复制
		copy() {
			let value = document.getElementById("copyword");
			value.select();
			document.execCommand("Copy");
			this.$Message.success("复制成功");
			value.blur();
		},
		goIndex() {
			this.$router.push({name: 'm-index'});
		},
		playVideo() {
			this.videoShow = true;
			document.getElementById('video').play();
			document.getElementById("bg_voice").pause();
		},
		hideVideo() {
			this.videoShow = false;
			document.getElementById('video').pause();
			document.getElementById("bg_voice").play();
		},
		chooseRole(index) {
			this.roleChooseIndex = index;
		},
		playJapanVoice() {
			if(this.chinaVoiceRoot.played) {
				this.chinaVoiceRoot.pause();
			}
			if (this.japanVoiceRoot.paused) {
				this.japanVoiceRoot.play();
				// document.getElementById("bg_voice").pause();
			} else {
				this.japanVoiceRoot.pause();
				// document.getElementById("bg_voice").play();
			}
		},
		playJapanVoice1(index) {
			this.roleChooseIndex = index;
			this.$nextTick(() => {
				this.playJapanVoice();
			});
		},
		playChinaVoice() {
			if(this.japanVoiceRoot.played) {
				this.japanVoiceRoot.pause();
			}
			if (this.chinaVoiceRoot.paused) {
				this.chinaVoiceRoot.play();
				// document.getElementById("bg_voice").pause();
			} else {
				this.chinaVoiceRoot.pause();
				// document.getElementById("bg_voice").play();
			}
		},
		playChinaVoice1(index) {
			this.roleChooseIndex = index;
			this.$nextTick(() => {
				this.playChinaVoice();
			});
		},
		showActivity(number) {
			this.activityShow = true;
			this.activityNumber = number;
		},
		goPage() {
			window.open('https://beian.miit.gov.cn/', '_blank')
		}
	},
}
</script>
